import React, { Fragment } from "react";
import { graphql, useStaticQuery } from "gatsby";
import Footer from "./footer";
import Header from "./header";
import CookiesBanner from "./CookiesBanner";

const Layout = ({ children }) => {
  const { sanitySitesettings } = useStaticQuery(graphql`
    {
      sanitySitesettings {
        cursor {
          enable
          color {
            hex
          }
        }
        header {
          logo {
            alt
            image {
              asset {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: WEBP
                )
              }
            }
          }
          menuLinks {
            linkTitle
            linkType
            slug: linkSlug {
              current
            }
            url
            sectionId
          }
          ctaButtonText
        }
        footer {
          footerLogo {
            alt
            image {
              asset {
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: WEBP
                )
              }
            }
          }
          about {
            title
            description
          }
          pagesLinks {
            title
            pagesLinks {
              linkTitle
              linkType
              slug: linkSlug {
                current
              }
              url
              sectionId
            }
          }
          getInTouch {
            title
            email {
              icon {
                asset {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: BLURRED
                    formats: WEBP
                  )
                }
              }
              text
              url
            }
            phone {
              icon {
                asset {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: BLURRED
                    formats: WEBP
                  )
                }
              }
              text
              url
            }
            address {
              icon {
                asset {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: BLURRED
                    formats: WEBP
                  )
                }
              }
              text
            }
          }
        }
        socialLinks {
          icon {
            asset {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: BLURRED
                formats: WEBP
              )
            }
          }
          text
          url
        }
        _rawCc
      }
    }
  `);
  return (
    <Fragment>
      <Header
        data={sanitySitesettings.header}
        socialLinks={sanitySitesettings.socialLinks}
      />
      {children}
      <Footer
        footer={sanitySitesettings.footer}
        cc={sanitySitesettings._rawCc}
        socialLinks={sanitySitesettings.socialLinks}
      />
      <CookiesBanner />
    </Fragment>
  );
};

export default Layout;
